import type { ReqSla } from 'rest/models';
import type { State } from 'state';

export const getReqSlas = (state: State, requestKey: string): ReqSla[] | undefined =>
	state.persisted.reqSlas?.[requestKey];
